import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Ellipsis = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.0312 25C32.0312 28.8867 28.8867 32.0312 25 32.0312C21.1133 32.0312 17.9688 28.8867 17.9688 25C17.9688 21.1133 21.1133 17.9688 25 17.9688C28.8867 17.9688 32.0312 21.1133 32.0312 25ZM42.1875 17.9688C38.3008 17.9688 35.1562 21.1133 35.1562 25C35.1562 28.8867 38.3008 32.0312 42.1875 32.0312C46.0742 32.0312 49.2188 28.8867 49.2188 25C49.2188 21.1133 46.0742 17.9688 42.1875 17.9688ZM7.8125 17.9688C3.92578 17.9688 0.78125 21.1133 0.78125 25C0.78125 28.8867 3.92578 32.0312 7.8125 32.0312C11.6992 32.0312 14.8438 28.8867 14.8438 25C14.8438 21.1133 11.6992 17.9688 7.8125 17.9688Z"
        fill={color}
      />
    </svg>
  )
}
